<template>
  <v-card style="width: 100%" class="mx-2 mb-4">
    <v-card-title
      >{{ actionIndex + 1 }}. {{ action.title }}
      <v-spacer />
      <v-icon v-if="!action.isValid" color="error">warning</v-icon>
      <v-btn icon @click="$emit('edit')">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn v-if="canDelete" icon @click="$emit('delete')">
        <v-icon>delete_forever</v-icon>
      </v-btn>
      <v-btn icon @click="isExpanded = !isExpanded">
        <v-icon>{{ isExpanded ? "expand_less" : "expand_more" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="isExpanded">
      <div v-html="action.content" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    actionIndex: {
      type: Number,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
    action: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {},
};
</script>
